import { gql } from '@apollo/client'

export const reorderGalleryImageLikesMutation = gql`
  mutation ReorderGalleryImageLikes($records: [GalleryImageLikeIndexChangeInput!]!) {
    reorderGalleryImageLikes(galleryImagesLikes: $records)
  }
`
